import { config } from '../config/environment';

/**
 * Base API sans le suffixe /api (ex: http://localhost:8000)
 */
function getApiOrigin(): string {
  const base = config.apiUrl.replace(/\/api\/?$/, '');
  return base || 'https://api26.sherlook.fr';
}

/**
 * URL complète d’une image d’annonce (CRA : pas de proxy Next comme /uploads/…)
 */
export function getAnnouncementImageUrl(imagePath: string | null | undefined): string {
  if (!imagePath) return '';
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  if (imagePath.startsWith('/uploads/')) {
    return `${getApiOrigin()}${imagePath}`;
  }
  if (imagePath.startsWith('/')) {
    return `${getApiOrigin()}${imagePath}`;
  }
  return `${getApiOrigin()}/uploads/announcements/${imagePath}`;
}

/**
 * Première image d’annonce, ou image par défaut de la catégorie.
 */
export function getAnnouncementThumbUrl(
  images: string[] | null | undefined,
  categoryDefaultRelativeUrl: string | null | undefined
): string {
  const first = images?.find((x) => x && String(x).trim());
  if (first) return getAnnouncementImageUrl(first);
  if (categoryDefaultRelativeUrl) return getAnnouncementImageUrl(categoryDefaultRelativeUrl);
  return '';
}

/**
 * URL complète du logo partenaire (`location_provider.logo` / `logo_url` API).
 */
export function getProviderLogoUrl(
  logoUrl: string | null | undefined,
  logoFilename: string | null | undefined
): string {
  if (logoUrl && String(logoUrl).trim()) {
    return getAnnouncementImageUrl(logoUrl);
  }
  if (logoFilename && String(logoFilename).trim()) {
    return `${getApiOrigin()}/uploads/logos/${logoFilename}`;
  }
  return '';
}
